import React, { Component } from 'react';
import './Home.css';

class Home extends Component {
  render() {
    return (
    <div>
      <header id="QuebecISKFHeader">
        <div id="homeImageHeader"></div>
        <div id="ShotokanLogoContainer">
          <img id="ShotokanLogo" src="/images/logos/Shotokan.png" alt="Shotokan Logo" />
        </div>
        <div class="container page-content" id="homeHeaderIntro">
          <article>
            <h1 class="centered-h">Québec ISKF</h1>
            <p>&nbsp;</p>
            <p>Québec ISKF est une association québécoise de dojos de karaté-do de style Shotokan. Sa mission principale est de promouvoir, organiser et régir la pratique du karaté selon les normes et standards diffusés par ISKF (International Shotokan Karate Federation).</p>
            <p>Une ambiance chaleureuse règne au sein des 18 dojos membres de Québec ISKF. Une attention particulière est accordée à tous les pratiquants afin de bien les accompagner vers l'atteinte de leurs objectifs personnels.</p>
            <p>Venez découvrir votre prochaine passion en rejoignant un dojo membre de Québec ISKF!</p>
          </article>
          
          
          <div class="row box-link-row">
            <a class="box-link-column dojo-box-column col-sm-6" href="/dojo">  
              <div class="box-link dojo-bkg">
                Trouver votre Dojo
              </div>
            </a>
            <a class="box-link-column events-box-column col-sm-6" href="/calendrier">  
              <div class="box-link events-bkg">
                Calendrier 2019
              </div>
            </a>
          </div>
        </div>
      </header>
    </div>
    );
  }
}

/**
 <article id="newsContainer">
            <h1 class="centered-h">Nouvelles</h1>
            <p>&nbsp;</p>
            <hr />
            <h4 class="redText">KANGEIKO 2019</h4>
            <p>Cher amis ISKF, nous aurons l’honneur de recevoir <strong>Shihan Hiroyoshi Okazaki 9e Dan</strong> dans le cadre du prochain camp d’hiver, le QUÉBEC KANGEIKO 2019 du <strong>14 au 17 mars prochain.</strong></p>
            <p><a href="/nouvelles/kangeiko2019">Plus d'informations...</a></p>
          </article>
 */

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/Home.js